import { Cookies } from '@ok/blade';

import {
  LOCALSTORAGE_KEY,
  COOKIE_KEY,
  MIGRATION_STATUS,
  LOCAL_STORAGE_TIME_KEY,
  TRADE_LOCAL_STORAGE_TIME_KEY,
} from './constant';

export function saveUserMigrationData(data) {
  const migrationData = JSON.stringify(data);
  // cookie作用是okj-web模版使用
  Cookies.set(
    COOKIE_KEY,
    data.migrationStatus === MIGRATION_STATUS.migrationSuccess
  );
  // localstorage作用同时其他tab页面
  localStorage.setItem(LOCALSTORAGE_KEY, migrationData);
}

export function userMigrationDataChange(data) {
  saveUserMigrationData({ ...window.okGlobal.userMigration, ...data });
}

export function cleanUserMigrationData() {
  Cookies.remove(COOKIE_KEY, '');
  const localStorageKey = [
    LOCALSTORAGE_KEY,
    LOCAL_STORAGE_TIME_KEY,
    TRADE_LOCAL_STORAGE_TIME_KEY,
  ];
  localStorageKey.forEach((key) => {
    localStorage.removeItem(key);
  });
}
